import { inject, Injectable } from '@angular/core';
import { TimezoneService } from '@lx/quote-tool/shared/services';
import { Observable, map } from 'rxjs';

/**
 * Service to provide default values for class time and timezone.
 * Centralizes the logic used across multiple services to ensure consistency.
 */
@Injectable({ providedIn: 'root' })
export class ClassTimeTimezoneDefaultsService {
  private readonly timezoneService = inject(TimezoneService);

  /**
   * Gets the default class time label.
   *
   * @returns Default class time label: "I will decide later"
   */
  getDefaultClassTimeLabel(): string {
    return $localize`I will decide later`;
  }

  /**
   * Gets the browser timezone name as an observable.
   *
   * @returns Observable of browser timezone name, or undefined if not available
   */
  getBrowserTimezoneName$(): Observable<string | undefined> {
    return this.timezoneService.timezones$.pipe(
      map((timezones) => {
        const browserTimezone = this.timezoneService.buildTimezoneFromBrowser(timezones);
        return browserTimezone?.name;
      }),
    );
  }
}
